import React from 'react';
import PropTypes from 'prop-types';
import {ToastContainer as PepsicoDsToastContainer} from '@pepsico-ds/ui';

/**
 * ToastContainer component that renders a PepsicoDsToastContainer with properties from props.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.data - The data to display in the toast notifications.
 * @param {boolean} [props.showActionIcon=true] - Optional boolean to show action icon.
 * @param {boolean} [props.isDark=true] - Optional boolean to indicate dark mode styling for the toast notifications.
 * @param {string} [props.id=''] - Optional additional id to apply to the toast container.
 * @param {string} [props.className=''] - Optional additional class names to apply to the toast container.
 * @param {('top-right'|'bottom-right')} [props.position='top-right'] - Optional string to indicate the position of the toast notifications.
 * @returns {JSX.Element} The rendered PepsicoDsToastContainer component.
 */
const ToastContainer = ({
  data,
  showActionIcon = true,
  isDark = true,
  id,
  className,
  position = 'top-right'
}) => {
  return (
    <PepsicoDsToastContainer
      data-testid={`toast_container` + (id ? `_${id}` : '')}
      id={`toast_container` + (id ? `_${id}` : '')}
      data={data}
      showActionIcon={showActionIcon}
      isDark={isDark}
      position={position}
      className={className}
    />
  );
};

ToastContainer.propTypes = {
  data: PropTypes.array.isRequired,
  showActionIcon: PropTypes.bool,
  isDark: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  position: PropTypes.oneOf(['top-right', 'bottom-right'])
};

export default React.memo(ToastContainer);
